import React from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Header from "../components/Header";

const Layout = () => {
  return window.location === window.parent.location ? (
    <React.Fragment>
      <ToastContainer
        closeOnClick={true}
        hideProgressBar={true}
        autoClose={3000}
        theme="dark"
        position="bottom-left"
      />
      <Header />
      <div className="videos-layout-content">
        <Outlet />
      </div>
    </React.Fragment>
  ) : null;
};

export default Layout;
